export default __webpack_public_path__ + "static/media/ad_S2.0363855a.png";